/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import {KTSVG, toAbsoluteUrl} from '../../../_metronic/helpers'
import {Link} from 'react-router-dom'
import {useLocation} from 'react-router-dom'
import * as getUserInfo from '../../../app/modules/auth/GetUserInfo'

const ProfileHeader: React.FC = () => {
  const location = useLocation()
  const chartFunc = (value: any) => {
    // console.log('value=', value.charAt(0))
    let chatAt_value = value.charAt(0);
    return chatAt_value;
}
  return (
    <div className='card mb-5 mb-xl-10 mt-10'>
      <div className='card-body pt-9 pb-0'>
        <div className='d-flex flex-wrap flex-sm-nowrap mb-3'>
          <div className='me-7 mb-4'>
            <div className='symbol symbol-100px symbol-lg-100px symbol-fixed position-relative'>
              {/* <img src={getUserInfo.domainUrl()+getUserInfo.userAvatar()} alt='Metornic' /> */}
              {/* {getUserInfo.userAvatar()} */}
              {
                getUserInfo.userAvatar()?
                (
                    <>
                    <div className="profilePageAvatar symbol symbol-100px symbol-lg-120px symbol-fixed position-relative text-uppercase">
                    <img width="100%" className={"symbol-label text-inverse-warning fw-bolder text-uppercase img-alt-100 bg-img-" + chartFunc(getUserInfo.fullName())} src={getUserInfo.domainUrl()+getUserInfo.userAvatar()} alt={chartFunc(getUserInfo.fullName())} />
                       
                        {/* <img src={getUserInfo.domainUrl()+getUserInfo.userAvatar()} alt='Metornic' /> */}
                    </div>
                    </>
                ):(
                    getUserInfo.fullName() ?
                    (
                        <div className="profilePageAvatar symbol symbol-100px symbol-lg-120px symbol-fixed position-relative text-uppercase">
                            <span className={'profilePageAvatarTxt symbol-label bg-light-danger text-white fs-30 fw-bolder bg-' + getUserInfo.fullName().charAt(0)}>
                                {getUserInfo.fullName().charAt(0)}
                            </span>
                        </div>
                    ):(
                      <div className="profilePageAvatar symbol symbol-100px symbol-lg-120px symbol-fixed position-relative text-uppercase">
                          <span className={'profilePageAvatarTxt symbol-label bg-light-danger text-white fs-30 fw-bolder bg-' + getUserInfo.email().charAt(0)}>
                              {getUserInfo.email().charAt(0)}
                          </span>
                      </div>
                    )
                )
              }
            </div>
          </div>

          <div className='flex-grow-1'>
            <div className='d-flex justify-content-between align-items-start flex-wrap mb-2'>
              <div className='d-flex flex-column'>
                <div className='d-flex align-items-center mb-2'>
                  <span className='text-gray-800 text-hover-primary fs-2 fw-bolder me-1'>
                    {getUserInfo.fullName()}
                  </span>
                </div>

                <div className='d-flex flex-wrap fw-bold fs-6 mb-4 pe-2'>
                  <span
                    className='d-flex align-items-center text-gray-400 text-hover-primary me-5 mb-2'
                  >
                    <KTSVG
                      path='/media/icons/duotune/communication/com006.svg'
                      className='svg-icon-4 me-1'
                    />
                    {
                      getUserInfo.userType() == 'internal'?
                      (
                        getUserInfo.userType()+' '
                      ):('')
                    }
                    {getUserInfo.roleLabel()}
                  </span>
                  <span
                    className='d-flex align-items-center text-gray-400 text-hover-primary mb-2'
                  >
                    <KTSVG
                      path='/media/icons/duotune/communication/com011.svg'
                      className='svg-icon-4 me-1'
                    />
                    {getUserInfo.email()}
                  </span>
                </div>
              </div>

              <div className='d-flex'>
                {
                  location.pathname === '/profile/overview'?
                  (
                    <Link
                      to={'/profile/settings'}
                      className='btn btn-sm btn-primary fw-bolder'
                    >
                      {/* <i className="bi bi-pencil-square me-1"></i>  */}
                      <span className="svg-icon svg-icon-muted svg-icon-18"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path opacity="0.3" fill-rule="evenodd" clip-rule="evenodd" d="M2 4.63158C2 3.1782 3.1782 2 4.63158 2H13.47C14.0155 2 14.278 2.66919 13.8778 3.04006L12.4556 4.35821C11.9009 4.87228 11.1726 5.15789 10.4163 5.15789H7.1579C6.05333 5.15789 5.15789 6.05333 5.15789 7.1579V16.8421C5.15789 17.9467 6.05333 18.8421 7.1579 18.8421H16.8421C17.9467 18.8421 18.8421 17.9467 18.8421 16.8421V13.7518C18.8421 12.927 19.1817 12.1387 19.7809 11.572L20.9878 10.4308C21.3703 10.0691 22 10.3403 22 10.8668V19.3684C22 20.8218 20.8218 22 19.3684 22H4.63158C3.1782 22 2 20.8218 2 19.3684V4.63158Z" fill="currentColor"/>
                        <path d="M10.9256 11.1882C10.5351 10.7977 10.5351 10.1645 10.9256 9.77397L18.0669 2.6327C18.8479 1.85165 20.1143 1.85165 20.8953 2.6327L21.3665 3.10391C22.1476 3.88496 22.1476 5.15129 21.3665 5.93234L14.2252 13.0736C13.8347 13.4641 13.2016 13.4641 12.811 13.0736L10.9256 11.1882Z" fill="currentColor"/>
                        <path d="M8.82343 12.0064L8.08852 14.3348C7.8655 15.0414 8.46151 15.7366 9.19388 15.6242L11.8974 15.2092C12.4642 15.1222 12.6916 14.4278 12.2861 14.0223L9.98595 11.7221C9.61452 11.3507 8.98154 11.5055 8.82343 12.0064Z" fill="currentColor"/>
                        </svg>
                      </span>
                      Edit
                    </Link>
                  ):(
                    <Link
                      to={'/profile/overview'}
                      className='btn btn-sm btn-primary fw-bolder'
                    >
                      {/* <i className="bi bi-eye me-1"></i>  */}
                      <span className="svg-icon svg-icon-muted svg-icon-18"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M21.7 18.9L18.6 15.8C17.9 16.9 16.9 17.9 15.8 18.6L18.9 21.7C19.3 22.1 19.9 22.1 20.3 21.7L21.7 20.3C22.1 19.9 22.1 19.3 21.7 18.9Z" fill="currentColor"/>
                        <path opacity="0.3" d="M11 20C6 20 2 16 2 11C2 6 6 2 11 2C16 2 20 6 20 11C20 16 16 20 11 20ZM11 4C7.1 4 4 7.1 4 11C4 14.9 7.1 18 11 18C14.9 18 18 14.9 18 11C18 7.1 14.9 4 11 4ZM8 11C8 9.3 9.3 8 11 8C11.6 8 12 7.6 12 7C12 6.4 11.6 6 11 6C8.2 6 6 8.2 6 11C6 11.6 6.4 12 7 12C7.6 12 8 11.6 8 11Z" fill="currentColor"/>
                        </svg>
                      </span>
                      Overview
                    </Link>
                  )
                }
              </div>
            </div>
          </div>
        </div>

        <div className='customNavTabs'>
          <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap'>
            <li className='nav-item'>
              <Link
                className={
                  `nav-link text-active-primary me-6 ` +
                  ((location.pathname === '/profile/overview' || location.pathname === '/profile/settings') && 'active')
                }
                to='/profile/overview'
              >
                Overview
              </Link>
            </li>
          </ul>
        </div>

      </div>
    </div>
  )
}

export {ProfileHeader}
